// Import the countries data and helper functions from the local data file
import { getAllCountries as getAll, getRandomCountries } from '../data/countries';

// Simulate API calls using the local data
export const fetchCountries = async (count = 10) => {
  try {
    // Simulate network delay for a more realistic experience
    await new Promise(resolve => setTimeout(resolve, 300));
    return getRandomCountries(count);
  } catch (error) {
    console.error('Error fetching countries:', error);
    throw error;
  }
};

export const getAllCountries = async () => {
  try {
    // Simulate network delay for a more realistic experience
    await new Promise(resolve => setTimeout(resolve, 300));
    return getAll();
  } catch (error) {
    console.error('Error fetching all countries:', error);
    throw error;
  }
};
